<template>
  <div id="app">
    <keep-alive include="achievement">
      <router-view id="page" :style="height" />
    </keep-alive>
  </div>
</template>

<script>
import { rem } from "./public/rem";
export default {
  name: "App",
  created() {
    rem(this);
    console.log(localStorage,"localStorage")
  },
  mounted() {
    let loading = document.getElementById("Loading");
    if (loading != null) {
      document.body.removeChild(loading);
    }
  },
  computed: {
    height() {
      return this.$store.getters.getHeight;
    },
  },
};
</script>

<style lang="scss">
div {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.nav-srcoll {
  overflow-y: auto;
  height: calc(100% - 2.2rem);
}
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#page {
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.layout-row {
  display: flex;
  flex-direction: row;
}
.layout-col {
  display: flex;
  flex-direction: column;
}
.font-21-fff {
  font-size: 1.05rem;
  color: #fff;
}
.font-12-fff {
  font-size: 0.6rem;
  color: #fff;
}
.font-11-999{
  font-size: 0.55rem;
  color: #999;
}
.font-13-fff {
  font-size: 0.65rem;
  color: #fff;
}
.font-18-fff {
  font-size: 0.9rem;
  color: #fff;
}
.font-30-fff {
  font-size: 1.5rem;
  color: #fff;
}
.font-10-ff6 {
  font-size: 0.5rem;
  color: #ff6a63;
}
.font-18-333 {
  font-size: 0.9rem;
  color: #333;
}
.font-14-999 {
  font-size: 0.7rem;
  color: #999;
}
.font-14-333 {
  font-size: 0.7rem;
  color: #333;
}
.font-14-666 {
  font-size: 0.7rem;
  color: #666;
}
.font-15-333 {
  font-size: 0.75rem;
  color: #333;
}
.font-15-666 {
  font-size: 0.75rem;
  color: #666;
}
.font-15-999 {
  font-size: 0.75rem;
  color: #999;
}
.font-15-ccc {
  font-size: 0.75rem;
  color: #ccc;
}
.font-16-333 {
  font-size: 0.8rem;
  color: #333;
}
.font-16-666 {
  font-size: 0.8rem;
  color: #666;
}
.font-13-666 {
  font-size: 0.65rem;
  color: #666;
}
.font-13-333 {
  font-size: 0.65rem;
  color: #333;
}
.font-12-666 {
  font-size: 0.6rem;
  color: #666;
}
.font-12-333 {
  font-size: 0.6rem;
  color: #333;
}
.font-10-666 {
  font-size: 0.5rem;
  color: #666;
}
.font-14-fff {
  font-size: 0.7rem;
  color: #fff;
}
.font-15-fff {
  font-size: 0.75rem;
  color: #fff;
}
.font-10-fff {
  font-size: 0.5rem;
  color: #fff;
}
.b {
  font-weight: bold;
}
.f-c {
  align-items: center;
}
.f-j-c {
  justify-content: center;
}
.f-e {
  align-items: flex-end;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.f-j-b {
  justify-content: space-between;
}
.Collage,
.Praise {
  .swiper-wrapper {
    display: block;
  }
}
.font-12-fd5 {
  color: #fd5b54;
  font-size: 0.6rem;
}
.font-16-fff {
  font-size: 0.8rem;
  color: #fff;
}
.font-12-999 {
  font-size: 0.6rem;
  color: #999;
}
.font-16-ff8 {
  font-size: 0.8rem;
  color: #ff8932;
}
.f-j-e {
  justify-content: flex-end;
}

/*弹层动画（从上往下）*/

.fadeIn {
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
}

@keyframes fadeInDown {
  0% {
    -webkit-transform: translate3d(0, -20%, 0);
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    opacity: 0;
  }
  100% {
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}

@-webkit-keyframes fadeInDown {
  0% {
    -webkit-transform: translate3d(0, -20%, 0);
    opacity: 0;
  }
  100% {
    -webkit-transform: none;
    opacity: 1;
  }
}

/*弹层动画（从下往上）*/

.fadelogIn {
  -webkit-animation: fadelogIn 0.4s;
  animation: fadelogIn 0.4s;
}

@keyframes fadelogIn {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes fadelogIn {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
  }
  100% {
    -webkit-transform: none;
  }
}

/*弹层动画（从右往左）*/

.fadeleftIn {
  -webkit-animation: fadeleftIn 0.4s;
  animation: fadeleftIn 0.4s;
}

@keyframes fadeleftIn {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes fadeleftIn {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
  }
  100% {
    -webkit-transform: none;
  }
}

/*弹层动画（放大）*/

.popIn {
  -webkit-animation: fadeleftIn 0.4s;
  animation: fadeleftIn 0.4s;
  -webkit-animation-name: popIn;
  animation-name: popIn;
}

@-webkit-keyframes popIn {
  0% {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0.5, 0.5, 0.5);
    opacity: 0;
  }
  50% {
    -webkit-animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
    animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    -webkit-animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 1;
  }
}

@keyframes popIn {
  0% {
    -webkit-transform: scale3d(0, 0, 0);
    transform: scale3d(0.5, 0.5, 0.5);
    opacity: 0;
  }
  50% {
    -webkit-animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
    animation-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    -webkit-animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 1;
  }
}

.font-10-333 {
  font-size: 0.5rem;
  color: #333;
}
.font-14-000 {
  font-size: 0.7rem;
  color: #000;
}
.font-14-ccc{
   font-size: 0.7rem;
  color: #ccc;
}

</style>



// WEBPACK FOOTER //
// src/App.vue